/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import { IReportScheduleTranslation } from '../../types/common/reportSchedule';

export const initialReportSchedule: IReportScheduleTranslation = {
    description: '',
    period: {
        label: '',
        labelNewSubscribers: '',
        D: {
            newSubscribersPrompt: '',
        },
        M: {
            label: '',
            newSubscribersPrompt: '',
            prompt: '',
        },
        W: {
            label: '',
            newSubscribersPrompt: '',
        },
    },
    time: {
        hours: '',
        label: '',
        minutes: '',
        prompt: '',
    },
};
